import { Modal, Button } from "react-bootstrap";
import styles from '../pa_checklist.module.scss';
import { usePAChecklist } from "../pa_checklist_context";

const PAChecklistModalCancelamento = () => {
  const { modalCancelamento, setModalCancelamento, cancelarChecklist, interfaceAtiva, romaneioSelecionado, referenciaSelecionada, setIdsCancelamento } = usePAChecklist();

  return (
    <Modal
      show={modalCancelamento}
      centered
      size={'lg'}
      onHide={() => setModalCancelamento(false)}
      backdropClassName={styles.backdrop_z_override}
    >
      <Modal.Header style={{ fontWeight: '500' }} closeButton>
        {interfaceAtiva === 101 && <>Cancelar Análise | Romaneio {romaneioSelecionado.romaneio_nf_saida}</>}
        {interfaceAtiva === 102 && <>Cancelar Análise | NF: {referenciaSelecionada.nf_entrada} | Produto: {referenciaSelecionada.produto} | Cor: {referenciaSelecionada.cor_produto}</>}
        {interfaceAtiva === 103 && <>Cancelar Prova de Roupa | NF: {referenciaSelecionada.nf_entrada} | Produto: {referenciaSelecionada.produto} | Cor: {referenciaSelecionada.cor_produto}</>}
      </Modal.Header>
      <Modal.Body className={styles.modal_body} style={{ fontWeight: '500', fontSize: '16px' }}>
        Tem certeza que deseja descartar todos os dados inseridos na análise até o momento?
        <br/>
        Essa ação é irrevesível.
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={'success'}
          onClick={() => {
            setIdsCancelamento([]);
            setModalCancelamento(false);
          }}
          style={{ margin: '0px auto' }}
          className={styles.footer_btn_processamento}
        >
          Voltar
        </Button>
        <Button
          variant={'danger'}
          onClick={cancelarChecklist}
          style={{ margin: '0px auto' }}
          className={styles.footer_btn_processamento}
        >
          Cancelar Análise
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PAChecklistModalCancelamento;
